/**
 * heraldry — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const heraldryPack: ToilePack = {
    slug: 'heraldry',
    category: 'heraldry',
    name: 'Crests & heraldry',
    tagline: tagline('crests', 'beasts', 'treatments'),
    chips: chips('beasts', 'treatments'),
    ratio: PORTRAIT,
    readings: [
        {key: 'lion', label: 'Lion crest', subject: 'a lion rampant, a crowned lion crest, two lion supporters'},
        {key: 'stag', label: 'Stag crest', subject: "a stag's head cabossed on a shield strewn with oak leaves"},
        {key: 'dragon', label: 'Dragon crest', subject: 'a winged dragon passant, three flames, two wyverns as supporters'},
    ],
    styles: [
        {key: 'blazon', label: 'Classic blazon', style: 'flat heraldic tinctures with black outlines and hatching', palette: 'gules red, azure, gold and silver', framing: 'one achievement, centered, symmetrical'},
        {key: 'minimal', label: 'Minimal line', style: 'single-weight black line, geometric simplification', palette: 'no fills, no shading', framing: 'one achievement, centered, symmetrical'},
        {key: 'ornate', label: 'Ornate mantling', style: 'acanthus mantling scrolling from the helm', palette: 'gold-leaf highlights on cream', framing: 'one achievement, centered, symmetrical'},
    ],
    directions: ['a falcon instead', 'in green and silver', 'with a motto scroll beneath'],
}
